<template>
  <div class="at-guppysidepopup at-chat" :class="{'wpguppy-rtl' : isRtl}">
    <div class="at-chatsidebar_float at-chatsidebar-widgetclose">
      <div class="at-chat_previewfloat">
        <guppy-chat-sidebar v-if="Number(userId)" v-show="isShowWidget" :isWidgetChat="true"/>
        <guppy-chat-messages v-if="isMessangerChat"/>
      </div>
    </div>

    <div class="at-chatfloatholder">
      <floating-chats />
      <div v-if="floatingWidgetEnable" class="at-chatfloat" @click.prevent="showWidget()">
        <span>
          <em v-if="isMobileView && getTotalUnreadCount" class="at-userchat_tab-noti">{{getTotalUnreadCount > 99 ? '+99' : getTotalUnreadCount}}</em>
          <a href="javascript:void(0);">
            <img :src="floatingIcon"  alt="floating button"> 
          </a>
        </span>
      </div>
    </div>
    <sign-in-box v-if="isShowWidget && !Number(userId)" @closeWidget="showWidget()" />
    <sidebar-popup />
  </div>
</template>

<script>
import GuppyFloatingChatList from "./GuppywidgetChatBox/GuppyFloatingChatList.vue";
import GuppyChatSidebar       from "./GuppyChatSidebar/GuppyChatSidebar.vue";
import { GUPPYCHAT_SETTINGS } from "../resources/constants";
import GuppyChatSidebarSettingPopup from "./GuppyChatMessages/GuppyChatSidebarSettingPopup.vue";
import GuppySignInWidgetBox from "./GuppywidgetChatBox/GuppySignInWidgetBox.vue"
import jQuery from "jquery";
import GuppyChatMessages from "./GuppyChatMessages/GuppyChatMessages/GuppyChatMessages.vue"
import { mapState } from 'vuex';

export default {
  name: 'widgetChatApp',
  components: { 
    SidebarPopup : GuppyChatSidebarSettingPopup,
    GuppyChatSidebar,
    FloatingChats : GuppyFloatingChatList,
    SignInBox : GuppySignInWidgetBox,
    GuppyChatMessages,
  },
  data(){
    return {
      isRtl         : false,
      isShowWidget  : false,
      floatingIcon  : GUPPYCHAT_SETTINGS.floatingIcon,
      floatingWidgetEnable  : GUPPYCHAT_SETTINGS.floatingWindowEnable,
    }
  },
  computed:{
    ...mapState({
      isMessangerChat   : (state) => state.isMessangerChat,
      isMobileView   : (state) => state.isMobileView,
    }),
    getTotalUnreadCount(){
      return this.$store.getters.getTotalUnreadCount
    },
    css: function(){
      return "<style> :root { --primguppycolor: " + GUPPYCHAT_SETTINGS.primaryColor+ "; --secguppycolor: " + GUPPYCHAT_SETTINGS.secondaryColor + "; --terguppycolor: " + GUPPYCHAT_SETTINGS.textColor + "; } </style>"
    }
  },
  methods:{
    showWidget(){
      if(Number(this.userId)){
        this.showChatWidget();
      } else {
        this.showSignInWidget();
      }
    },
    guppyAddClass(){
      let width = jQuery('.at-chat').width();
      if ( width <= 768){
        jQuery('.at-guppysidepopup').addClass('at-guppyside-responsive');
        jQuery(document).on("click",'.at-guppysidepopup .conversation-list .at-userbar, .at-guppysidepopup .user-list .at-btn-respond',function() {
          jQuery('.at-chat').addClass("at-opnchatbox")
        });
      }
      jQuery(document).on("click",'.at-backtolist',function() {
        jQuery('.at-chat').removeClass('at-opnchatbox')
      });
    },
    timeout(ms){
       return new Promise(resolve => setTimeout(resolve, ms));
    },
    async showChatWidget(){
      jQuery('.at-floatdropdownholder').hide();
      jQuery('.at-chatsidebar_float').toggleClass('at-chatsidebar-widgetclose');
      let width = jQuery('.at-chat').width();

      if(this.isShowWidget){
        await this.timeout(500);
        this.isShowWidget = false;
      }else{
        this.isShowWidget = true;
      }

      if ( width <= 768){
        let isMessangerChat = this.isShowWidget ? true : false;
        this.$store.commit('updateWidgetType', { isMessangerChat });
      }

    },
    showSignInWidget(){
      if(this.isShowWidget){
        this.isShowWidget = false;
      }else{
        this.isShowWidget = true;
      }
    }
  },
  created(){
    jQuery('head').prepend(this.css);
    let windowWidth =  jQuery( window ).width();
    if( windowWidth < 768 ) {
      this.$store.commit('updateWidgetType', { isMobileView : true });
    }
    this.isRtl = GUPPYCHAT_SETTINGS.isRtl;
    this.$store.commit('updateWindowWidth',{ windowWidth });
  },
  mounted(){
    this.guppyAddClass();
    this.$root.$on('showWidget',()=>{
      this.showWidget();
    })
  },
}
</script>